import {
    ADD_STEP,
    DELETE_STEP,
    DELETE_STEP_NUMBER,
    RECORD_STEP,
    DELETE_STEPS,
    UPDATE_STEP_PARAMETER,
    MOVE_STEPS,
    ALTER_STEP_PARAMETER,
    ALTER_TRACK_PARAMETER,
    TOGGLE_STEP,
    DELETE_PATTERN,
    ADD_EFFECT,
    DELETE_EFFECT,
    TOGGLE_EFFECT,
    MOVE_EFFECT,
    UPDATE_PARAMETER,
    UPDATE_TRACK_VOLUME,
    UPDATE_TRACK_MUTE,
    ADD_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINTS,
    REMOVE_AUTOMATION_BREAK_POINT,
    REMOVE_AUTOMATION_BREAK_POINTS,
    SNAP_TO_GRID,
    SNAP_AUTOMATION_BREAK_POINT,
    RECORD_AUTOMATION,
    LOAD_PROJECT_TRACKS,
    AUDITION_PRESET,
    UNMAP_PLANAR_PARAMETERS,
    BATCHED_ACTIONS} from './constants.js';

import AddStepAction from './actions/addStepAction.js';
import UnmapPlanarParameters from './actions/UnmapPlanarParameters.js';
import AddEffectAction from './actions/AddEffectAction.js';
import DeleteEffectAction from './actions/DeleteEffectAction.js';
import ToggleEffectAction from './actions/ToggleEffectAction.js';
import MoveEffectAction from './actions/MoveEffectAction.js';
import DeleteStepAction from './actions/deleteStepAction.js';
import DeleteStepNumberAction from './actions/deleteStepNumberAction.js';
import MoveStepsAction from './actions/moveStepsAction.js';
import DeleteStepsAction from './actions/deleteStepsAction.js';
import ToggleStepAction from './actions/toggleStepAction.js';
import DeletePatternAction from './actions/deletePatternAction.js';
import RecordStepAction from './actions/recordStepAction.js';
import UpdateStepParameterAction from './actions/updateStepParameterAction.js';
import UpdateParameterAction from './actions/UpdateParameterAction.js';
import SnapToGridAction from './actions/SnapToGridAction.js';
import UpdateTrackVolumeAction from './actions/UpdateTrackVolumeAction.js';
import UpdateTrackMuteAction from './actions/UpdateTrackMuteAction.js';
import AddAutomationBreakPointAction from './actions/AddAutomationBreakPointAction.js';
import RemoveAutomationBreakPointAction from './actions/RemoveAutomationBreakPointAction.js';
import RemoveAutomationBreakPointsAction from './actions/RemoveAutomationBreakPointsAction.js';
import MoveAutomationBreakPointAction from './actions/MoveAutomationBreakPointAction.js';
import MoveAutomationBreakPointsAction from './actions/MoveAutomationBreakPointsAction.js';
import SnapAutomationBreakPoint from './actions/SnapAutomationBreakPoint.js';
import RecordAutomationAction from './actions/RecordAutomationAction.js';
import LoadProjectTracks from './actions/LoadProjectTracks.js';
import AuditionPreset from './actions/AuditionPreset.js';

class ActionsMixin {
    constructor(sequencerEngine) {
        this.addStepAction = new AddStepAction(sequencerEngine);
        this.deleteStepAction = new DeleteStepAction(sequencerEngine);
        this.deleteStepNumberAction = new DeleteStepNumberAction(sequencerEngine);
        this.moveStepsAction = new MoveStepsAction(sequencerEngine);
        this.deleteStepsAction = new DeleteStepsAction(sequencerEngine);
        this.toggleStepAction = new ToggleStepAction(sequencerEngine);
        this.deletePatternAction = new DeletePatternAction(sequencerEngine);
        this.recordStepAction = new RecordStepAction(sequencerEngine);
        this.updateStepParameterAction = new UpdateStepParameterAction(sequencerEngine);
        this.addEffectAction  = new AddEffectAction(sequencerEngine);
        this.deleteEffectAction  = new DeleteEffectAction(sequencerEngine);
        this.toggleEffectAction  = new ToggleEffectAction(sequencerEngine);
        this.moveEffectAction  = new MoveEffectAction(sequencerEngine);
        this.updateParameterAction = new UpdateParameterAction(sequencerEngine);
        this.updateTrackVolumeAction = new UpdateTrackVolumeAction(sequencerEngine);
        this.updateTrackMuteAction = new UpdateTrackMuteAction(sequencerEngine);
        this.addAutomationBreakPointAction = new AddAutomationBreakPointAction(sequencerEngine);
        this.removeAutomationBreakPointAction = new RemoveAutomationBreakPointAction(sequencerEngine);
        this.removeAutomationBreakPointsAction = new RemoveAutomationBreakPointsAction(sequencerEngine);
        this.moveAutomationBreakPointAction = new MoveAutomationBreakPointAction(sequencerEngine);
        this.moveAutomationBreakPointsAction = new MoveAutomationBreakPointsAction(sequencerEngine);
        this.snapToGridAction = new SnapToGridAction(sequencerEngine);
        this.snapAutomationBreakPoint = new SnapAutomationBreakPoint(sequencerEngine);
        this.recordAutomationAction = new RecordAutomationAction(sequencerEngine);
        this.loadProjectTracks = new LoadProjectTracks(sequencerEngine);
        this.unmapPlanarParameters = new UnmapPlanarParameters(sequencerEngine);
        this.auditionPreset = new AuditionPreset(
            sequencerEngine);
    }

    // maps the given action json to the action class to be run
    getAction(action) {
        switch (action.type) {
        case ADD_STEP:
            return this.addStepAction;
        case DELETE_STEP:
            return this.deleteStepAction;
        case DELETE_STEP_NUMBER:
            return this.deleteStepNumberAction;
        case RECORD_STEP:
            return this.recordStepAction;
        case MOVE_STEPS:
            return this.moveStepsAction;
        case DELETE_STEPS:
            return this.deleteStepsAction;
        case TOGGLE_STEP:
            return this.toggleStepAction;
        case DELETE_PATTERN:
            return this.deletePatternAction;
        case UPDATE_STEP_PARAMETER:
            return this.updateStepParameterAction;
        case ADD_EFFECT:
            return this.addEffectAction;
        case DELETE_EFFECT:
            return this.deleteEffectAction;
        case TOGGLE_EFFECT:
            return this.toggleEffectAction;
        case MOVE_EFFECT:
            return this.moveEffectAction;
        case UPDATE_PARAMETER:
            return this.updateParameterAction;
        case UPDATE_TRACK_VOLUME:
            return this.updateTrackVolumeAction;
        case UPDATE_TRACK_MUTE:
            return this.updateTrackMuteAction;
        case ADD_AUTOMATION_BREAK_POINT:
            return this.addAutomationBreakPointAction;
        case REMOVE_AUTOMATION_BREAK_POINT:
            return this.removeAutomationBreakPointAction;
        case REMOVE_AUTOMATION_BREAK_POINTS:
            return this.removeAutomationBreakPointsAction;
        case MOVE_AUTOMATION_BREAK_POINT:
            return this.moveAutomationBreakPointAction;
        case MOVE_AUTOMATION_BREAK_POINTS:
            return this.moveAutomationBreakPointsAction;
        case SNAP_TO_GRID:
            return this.snapToGridAction;
        case SNAP_AUTOMATION_BREAK_POINT:
            return this.snapAutomationBreakPoint;
        case LOAD_PROJECT_TRACKS:
            return this.loadProjectTracks;
        case AUDITION_PRESET:
            return this.auditionPreset;
        case RECORD_AUTOMATION:
            return this.recordAutomationAction;
        case UNMAP_PLANAR_PARAMETERS:
            return this.unmapPlanarParameters;
        default:
            return undefined;
        }
    }

    makeCopyOfAction(action) {
        let copiedAction;
        switch (action.type) {
        case ADD_STEP:
            copiedAction = {... action};
            copiedAction.payload.step = copiedAction.payload.step.getCopy(true, true, true);
            return copiedAction;
        case DELETE_STEP:
            copiedAction = {... action};
            copiedAction.payload.step = copiedAction.payload.step.getCopy(true, true, true);
            return copiedAction;
        case RECORD_STEP:
            copiedAction = {... action};
            copiedAction.payload.step = copiedAction.payload.step.getCopy(true, true, true);
            return copiedAction;
        case MOVE_STEPS:
            copiedAction = {... action};
            copiedAction.payload.steps = action.payload.steps;
            return copiedAction;
        case DELETE_STEPS:
            copiedAction = {... action};
            copiedAction.payload.steps = action.payload.steps.map(
                step => step.getCopy(true, true, true));
            return copiedAction;
        case UPDATE_STEP_PARAMETER:
            copiedAction = {... action};
            copiedAction.payload.savedValue = action.payload.parameter.get();
            return copiedAction;
        case UPDATE_PARAMETER:
            copiedAction = {... action};
            copiedAction.payload.savedValue = action.payload.parameter.get();
            return copiedAction;
        case MOVE_AUTOMATION_BREAK_POINT:
            copiedAction = {... action};
            copiedAction.payload.savedStep = action.payload.point.step;
            copiedAction.payload.savedValue = action.payload.point.value;
            return copiedAction;
        default:
            return { ... action};
        }
    }
}

export default ActionsMixin;
